module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Land & housing-0fe750a9a2e7d52867c4d65510a49c68.png";